var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHeartLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "lhqxrv2uja",
    width: "182.8%",
    height: "182.8%",
    x: "-41.4%",
    y: "-41.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-301 -568) translate(302 569)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#FFF",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#lhqxrv2uja)",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M19.332 3.79c3.63 0 6.484 2.946 6.484 6.664 0 1.324-.34 2.598-1.01 3.887-1.21 2.325-2.8 4.017-7.898 8.8L14.8 25.106l-.646-.607-1.458-1.37c-5.075-4.75-6.676-6.451-7.888-8.772-.676-1.295-1.019-2.574-1.019-3.903 0-3.718 2.854-6.665 6.484-6.665 1.662 0 3.286.649 4.53 1.758 1.244-1.11 2.867-1.758 4.53-1.758zm-3.718 17.967c4.907-4.604 6.444-6.239 7.51-8.29.536-1.03.797-2.008.797-3.013 0-2.685-2.019-4.77-4.589-4.77-1.437 0-2.86.69-3.8 1.828l-.73.886-.73-.886c-.938-1.137-2.361-1.828-3.8-1.828-2.569 0-4.588 2.085-4.588 4.77 0 1.009.263 1.991.803 3.026 1.07 2.048 2.617 3.69 7.505 8.267l.813.764.81-.754z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28.421V28.421H0z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeartLive);
export default __webpack_public_path__ + "static/media/ic_heart_live.daad5b72783f2326729c1b2b78c8f99d.svg";
export { ForwardRef as ReactComponent };